/* PCのメガメニューを「マウスを乗せる」で開き、開いたら残す。（2026-08-31／2026-09-06改）
 *
 * Dawn標準の <details> はクリックでしか開かない。CSSだけではホバーで開けないため、
 * マウスが乗ったら open を付ける、という最小限のJSを足している。
 *
 * ■ 2026-09-06の変更：「離れたら閉じる」をやめた
 *   以前は上部バーの項目から離れて150msで閉じていた。バーとパネルの間に20pxのすき間があり、
 *   右下のカードへ斜めに動かすとその通過に150ms以上かかって閉じてしまっていた。
 *   いまは開いたら残す。閉じるのは次のときだけ：
 *     ① 上部バーの別の項目に乗せた（その項目に切り替わる）
 *     ② パネルの余白やページ本文をクリックした（assets/mega-menu-close.js）
 *     ③ Esc を押した／フォーカスが外れた（Dawn標準 details-disclosure.js）
 *     ④ リンクをクリックしてページ移動した
 *   マウスが離れただけでは閉じないので、開いたままページをスクロールして
 *   パネルの続き（画面に入りきらない下の段）を見られる。
 *   ※ パネルの高さ上限は component-header-mega.css 側で外してある（ページと一緒にスクロール）。
 *
 * 気をつけていること：
 *   ① マウスが使える環境だけ（(hover: hover) and (pointer: fine)）。
 *      スマホ・タブレットのタップは今までどおりクリックで開閉する。
 *   ② 乗せてから OPEN_DELAY（200ms）たってから開く。
 *      検索やカートへ行く途中でバーをかすめただけでは開かない（開きっぱなし防止）。
 *   ③ 別の項目へ切り替えるときは、前の項目がキーボード操作で開いていても閉じる
 *      （2つ同時に開かないように）。
 */
(function () {
  const OPEN_DELAY = 200;
  const pointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  let openTimer = null;

  function open(details) {
    if (details.hasAttribute('open')) return;
    details.setAttribute('open', '');
    const summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
  }

  function close(details) {
    if (!details.hasAttribute('open')) return;

    const holder = details.closest('header-menu');
    if (holder && typeof holder.close === 'function') {
      holder.close();
      return;
    }
    details.removeAttribute('open');
    const summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }

  function init() {
    const nav = document.querySelector('.cc-nav');
    if (!nav) return;

    const items = nav.querySelectorAll('li > header-menu > details.mega-menu');
    if (!items.length) return;

    items.forEach(function (details) {
      const area = details.closest('li') || details;

      area.addEventListener('mouseenter', function () {
        if (!pointer.matches) return;
        clearTimeout(openTimer);
        if (details.hasAttribute('open')) return;
        openTimer = setTimeout(function () {
          items.forEach(function (other) {
            if (other !== details) close(other);
          });
          open(details);
        }, OPEN_DELAY);
      });

      // 離れたら「開く予定」だけ取り消す。開いているものは閉じない
      area.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        openTimer = null;
      });
    });

    // Esc で閉じる。Dawn標準（details-disclosure.js）の Esc はフォーカスがメニューの中に
    // あるときしか効かないので、マウスで開いた（フォーカスが無い）ときのために足す
    document.addEventListener('keyup', function (event) {
      if (event.key !== 'Escape' && event.code !== 'Escape') return;
      items.forEach(close);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
